export default __webpack_public_path__ + "static/media/notification-icon.4e5df6c1.svg";